document.addEventListener("DOMContentLoaded", function () {
    // Function to move the square-placement element
    function moveSquarePlacement() {
        const productPrice = document.querySelector(".price-list");
        const squarePlacement = document.querySelector("square-placement");

        if (productPrice && squarePlacement) {
            productPrice.parentNode.insertBefore(squarePlacement, productPrice.nextSibling);
            console.log("Moved <square-placement> element after .price-list");
            observer.disconnect(); // Stop observing once the elements are found and moved
        }
    }

    // Observe changes in the DOM to detect when elements are rendered
    const observer = new MutationObserver(moveSquarePlacement);
    observer.observe(document.body, { childList: true, subtree: true });

    // Call the function initially in case elements are already present
    moveSquarePlacement();
});

